<form [formGroup]="formGroup">
  @if (!editMode) {
  <mat-form-field class="w-full" id="{{ id }}">
    <mat-label class="custom-label">{{ label }}</mat-label>
    <input id="{{ id }}Input" matInput type="text" readonly formControlName="{{ controlName }}" />
  </mat-form-field>
  } @if (editMode) {
  <mic-dropdown-search
    micDropdownAccessibility
    id="{{ id }}DropdownInput"
    appearance="fill"
    [widthConfig]="{ width: '100%' }"
    label="{{ label }}"
    [placeholder]="placeholder"
    emptyPlaceholder="No data found"
    allLabel="{{ translationService.translate('allText') }}"
    [multiple]="multipleOption"
    [requiredLabel]="translationService.translate('selectAtleastOneValueErrorText')"
    [formControlName]="controlName"
    [virtualScroll]="true"
    [data]="processedOptions"
    (openedChange)="onDropdownOpenedChange()"
  />
  }
</form>
